import { Divider, Stack } from '@mui/material';
import { AccordionUserDetails } from '../AccordionDetails';
import { DisabilityCertificateLinks } from './DisabilityCertificateLinks';
import { DisabilityClause } from './DisabilityClause';
import { Fragment } from 'react';
import { IDisabilitySections } from 'API/personalDetails';

interface IDisabilityAccordion {
  title: string;
  userDisability: {
    disabilityPercent: string;
    disabilitySections: IDisabilitySections[];
    disabilityStatus: string | undefined;
  };
}

export const DisabilityAccordion = ({
  title,
  userDisability,
}: IDisabilityAccordion) => {
  return (
    <AccordionUserDetails title={title}>
      <Divider
        aria-hidden={'true'}
        orientation={'horizontal'}
        sx={{ borderColor: 'primary.shade_100', marginBottom: '24px' }}
      />
      <Stack gap={'32px'}>
        <DisabilityCertificateLinks
          disabilityPercent={
            userDisability?.disabilitySections.find(
              (section) => section.disabilityPercent === '100%+'
            )
              ? '100%+'
              : `${userDisability.disabilityPercent.trim()}%`
          }
          disabilityStatus={userDisability?.disabilityStatus}
        />
        <Stack gap={'24px'} component={'ul'} margin={0} padding={0}>
          {userDisability?.disabilitySections?.map((clause, index) => (
            <Fragment key={index}>
              <Stack component={'li'} margin={0} padding={0}>
                <DisabilityClause clause={clause} />
              </Stack>
              {index !== userDisability.disabilitySections.length - 1 && (
                <Divider
                  aria-hidden={'true'}
                  orientation={'horizontal'}
                  sx={{ height: '1px', borderColor: 'primary.shade_100' }}
                />
              )}
            </Fragment>
          ))}
        </Stack>
      </Stack>
    </AccordionUserDetails>
  );
};
